import * as tslib_1 from "tslib";
import { listApi, formApi, userApi } from '../../../../../api';
import common from '../../../../../common/pc';
import ImportModals from '../../../../../form/src/common/components/import-data/import.vue';
import sheetFilter from '../../../../../form/src/common/components/import-data/sheet-filter/index.vue';
import UseRepeatModals from '../../../../../form/src/common/components/import-data/usename-repeat/index.vue';
import { FormSheetControl } from '../../../../../form/src/common/controls/form-sheet-control';
import { RelevanceFormControl } from '../../../../../form/src/common/controls/relevance-form-control';
import { UploadControl } from '../../../../../form/src/common/controls/upload-control';
import { FormControlValueService, ReverseQueryService } from '../../../../../form/src/common/services';
import BaseControlAdapter from '../../../../../form/src/renderer/components/pc/base-control-adapter.vue';
import { FormBuilderHelper } from '../../../../../form/src/renderer/controls/form-builder-helper';
import numberFilter from '../../../../../form/utils/number-filter';
import filterCard from '../../../../../list/src/components/pc/components/filter-card/filter-card.vue';
import { Button, Checkbox, Divider, Icon, Modal, Pagination, Popover, Spin, Tooltip } from '@h3/antd-vue';
import moment from 'moment';
import { Component, Inject, Prop, Watch } from 'vue-property-decorator';
import alledit from './alledit.vue';
import SheetComp from './sheet.vue';
let FormSheet = class FormSheet extends FormSheetControl {
    constructor() {
        super(...arguments);
        this.isFullScreen = false;
        // 分页配置项
        this.pageSizeOptions = ['10', '20', '50', '100', '200', '300'];
        this.pageSize = 10;
        this.pageIndex = 1;
        this.sheetImport = '22';
        this.importDataNum = null;
        this.queryActive = false;
        this.newCol = [];
        //二开
        this.isNewBtnShow = true;
        this.showModal2 = false;
        this.showModalLength = 0;
        /**
         * 子表导入,导出代码
         */
        this.showModal = false;
        // sheetParams:any = {}
        // 是否显示人员重复的弹框
        this.showRepeatModal = false;
        this.isShowRelevance = false;
        this.selected = [];
        this.importData = {
            headColumns: this.dataItem,
            queryField: '',
            secondImportData: [],
        };
        this.importStatu = {
            status: 0,
            successNum: 0,
            failNum: 0,
            fileName: '',
        };
        this.isShowQueryItem = false; // 是否显示查询条件
        this.queryConditionSource = [];
        this.queryData = {};
    }
    get canDelete() {
        return this.checkeds.some((c) => c);
    }
    get canEdits() {
        return this.checkeds.some((c) => c);
    }
    get total() {
        return this.rows.length;
    }
    get pageStart() {
        const start = (this.pageIndex - 1) * this.pageSize;
        return start;
    }
    get pageEnd() {
        let end = this.pageIndex * this.pageSize;
        if (end > this.total) {
            end = this.total;
        }
        return end;
    }
    get pagingRows() {
        return this.rows.slice(this.pageStart, this.pageEnd);
    }
    get relavanceControl() {
        const controlList = this.control.columns;
        const theControl = controlList && controlList.find((i) => {
            return i.key === this.control.options.importFormRelevanceForm;
        });
        return theControl;
    }
    get pagingCheckeds() {
        return this.checkeds.slice(this.pageStart, this.pageEnd);
    }
    get titleVisible() {
        return this.control.options.labelVisible;
    }
    getNewPopupContainer(triggerNode) {
        return triggerNode.parentNode.parentNode;
    }
    onIsEditChange() {
        // this.$set(this.control,'edit',!this.readonly);
        super.edit();
    }
    mounted() {
        let that = this;
        if (window.h3form.isNew && that.$route.query.startWorkflowCode === "SR") {
            window.h3form.srType.valueChange.subscribe(function (change) {
                if (change.value === "Without BLA") {
                    if (window.h3form.isNew && that.$route.query.startWorkflowCode === "SR") {
                        that.isNewBtnShow = true;
                    }
                }
                else {
                    if (window.h3form.isNew && that.$route.query.startWorkflowCode === "SR") {
                        that.isNewBtnShow = false;
                    }
                }
            });
        }
        if (window.h3form.isNew && this.$route.query.startWorkflowCode === "TSR")
            return this.isNewBtnShow = false;
        if (window.h3form.isNew && this.$route.query.startWorkflowCode === "SR")
            return this.isNewBtnShow = false;
    }
    //结束
    setControl() {
        const ctrl = this.getCtrl();
        if (!ctrl) {
            return;
        }
        sessionStorage.removeItem('sheet-' + this.id);
        this.reset();
        super.listenPropertyChange();
        this.initRows(this.canFull, 'pc');
        super.initStat();
        this.checkeds = this.rows.map(() => false);
        super.listenRowChange();
        if (this.canFull && this.control.edit) {
            super.edit();
        }
    }
    onCheck(checkeds) {
        this.checkeds.splice(this.pageStart, this.pageEnd - this.pageStart, ...checkeds);
    }
    onCheckAll(check) {
        this.checkeds = this.checkeds.map(() => check);
    }
    onColumnResize(data) {
        if (this.emitSheetColumnResize) {
            data.sheet = this.sheet;
            this.emitSheetColumnResize(data);
        }
    }
    onFreezeColumn(columnKey, freeze) {
        this.$emit('freezeColumn', columnKey, freeze);
    }
    onPageIndexChange(page, size) {
        this.pageIndex = page;
    }
    onPageSizeChange(page, size) {
        this.pageIndex = 1;
        this.pageSize = size;
    }
    // 批量编辑
    allEdit() {
        console.log(this.sheet, 'sheet');
        let indexs = [];
        for (let i = 0; i < this.checkeds.length; i++) {
            let s = this.checkeds[i];
            if (s) {
                indexs.push(i);
            }
        }
        this.showModalLength = indexs.length;
        this.showModal2 = true;
    }
    // 批量编辑确认
    onshowModal2() {
        this.$refs['allEdit'].emits();
    }
    // 批量编辑
    alledits(value) {
        console.log(value);
        this.showModal2 = false;
        this.showModalLength = 0;
        if (Object.values(value).length) {
            let indexs = [];
            for (let i = 0; i < this.checkeds.length; i++) {
                let s = this.checkeds[i];
                if (s) {
                    indexs.push(i);
                }
            }
            try {
                this.rows.forEach((d, i) => {
                    if (indexs.indexOf(i) > -1) {
                        Object.keys(value).forEach((k) => {
                            d.forEach((s) => {
                                if (value[k].key === s.key) {
                                    if ([1, 2, 4, 5, 6, 7, 19].indexOf(s.type) > -1) {
                                        // 短文本,长文本,数值,单选,复选,下拉
                                        if (s.type === 4) {
                                            // 数值
                                            console.log('value[k].value===>', value[k].value);
                                            s.controller.value = value[k].value * 1;
                                        }
                                        else {
                                            s.controller.value = value[k].value;
                                        }
                                    }
                                    else if (s.type === 3) {
                                        // 日期
                                        s.controller.value = new Date(value[k].value);
                                    }
                                }
                            });
                        });
                    }
                });
                this.$message.success(`${this.$i18n.locale === 'zh'
                    ? '操作成功'
                    : 'Successful operation'}`);
            }
            catch (error) {
                this.$message.error(`${this.$i18n.locale === 'zh'
                    ? '操作失败'
                    : 'operation failed'}`);
            }
        }
    }
    removeChecked() {
        this.importDataNum = null;
        let indexs = [];
        let indexCopy = [];
        for (let i = 0; i < this.checkeds.length; i++) {
            let s = this.checkeds[i];
            let row = this.rows[i];
            if (s && i < this.rows.length) {
                indexs.push(row[0].controller.options.rowIndex);
                indexCopy.push(i);
            }
        }
        // 二开开始
        if (window.h3form.formObj && window.h3form.formObj.bizObject.schemaCode === "facility") {
            for (const item of indexs) {
                const val = window.h3form.facility_remark_list.value[item];
                const userInfo = JSON.parse(window.sessionStorage.getItem('user'));
                if (val) {
                    let id = val.remarkName[0].id;
                    if (id !== userInfo.id) {
                        this.$message.error('You can only delete data that you created.');
                        return;
                    }
                }
            }
        }
        // 二开结束
        debugger;
        this.removeRows(indexs);
        // 子表筛选过后处理逻辑
        if (indexs.join() !== indexCopy.join()) {
            indexCopy
                .sort((a, b) => a - b)
                .reverse()
                .forEach((d) => {
                this.rows.splice(d, 1);
            });
            this.onCheckAll(false);
        }
        if (this.pagingRows.length === 0) {
            this.pageIndex = 1;
        }
    }
    copy(idx, row) {
        this.importDataNum = null;
        this.changeIsAddNew(false);
        super.copy(idx, row);
    }
    add(idx, vals) {
        this.importDataNum = null;
        if (typeof idx !== 'number' && vals === undefined) {
            this.changeIsAddNew(true);
        }
        const row = typeof idx === 'number' ? this.addRow(vals, idx) : this.addRow(vals);
    }
    splice(idx) {
        this.removeRow(idx);
    }
    rowInserted(index, row) {
        this.importDataNum = null;
        this.checkeds.splice(index, 0, false);
        if (this.control.edit) {
            super.edit();
        }
        this.syncScroll();
    }
    rowRemoved(index, row) {
        this.importDataNum = null;
        this.checkeds.splice(index, 1);
    }
    rowsInserted(index, rows) {
        this.importDataNum = null;
        const news = rows.map(() => false);
        this.checkeds.splice(index, 0, ...news);
        if (this.control.edit) {
            super.edit();
        }
        this.syncScroll();
    }
    rowsRemoved(indexs) {
        this.importDataNum = null;
        for (const index of indexs) {
            this.checkeds.splice(index, 1);
        }
    }
    syncScroll() {
        this.$nextTick(() => {
            const $sheet = this.$refs.sheet;
            if ($sheet) {
                $sheet.syncScrollLeft();
                $sheet.handleRootScroll();
            }
        });
    }
    importSheet() {
        this.importDataNum = null;
        this.showModal = true;
    }
    /**
     * reset
     */
    handleCancel() {
        this.importDataNum = null;
        let fileName = this.$refs.importModals.errorFile ||
            this.$refs.importModals.importFileName;
        if (fileName) {
            //清除临时文件
            listApi.deleteTemporaryFile({ fileName });
        }
        this.showModal = false;
    }
    /**
     * 导出
     */
    exportSheet() {
        this.importDataNum = null;
        const exportRows = [];
        // const ctrl:any = JSON.parse(JSON.stringify(this.ctrl));
        this.checkeds.forEach((r, index) => {
            //
            let row = this.rows[index];
            if (r && index < this.rows.length) {
                let i = row[0].controller.options.rowIndex;
                const value = this.ctrl.rows[i].value;
                if (value.id) {
                    exportRows.push(value.id);
                }
            }
        });
        const params = Object.assign({}, this.sheetParams);
        // 获取导出权限数据
        const schemaCode = this.sheetParams.subSchemaCode;
        const permissData = this.formPermission.dataPermissions[schemaCode];
        params.permiss = permissData;
        params.name =
            this.control.options.name +
                this.$t('cloudpivot.form.renderer.exportFile').toString();
        if (exportRows.length > 0) {
            params.objectIds = exportRows;
        }
        UploadControl.service.exportSheet(params, this);
    }
    // onListChange(val) {
    //   ;
    // };
    beforeCreate() {
        const comp = RelevanceFormControl.loadListSelector();
        this.$options.components.ListSelector = comp;
    }
    onModalOk() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // debugger
            const formControls = this.getFormControls();
            const dataitems = yield RelevanceFormControl.service.dataitemsOf(this.schemaCode);
            // 二开开始
            if (this.$route.query.startWorkflowCode === "witApplication" || this.$route.query.return.split('?')[0].split('/').includes('WIT_Application')) {
                let dataArray = [];
                let applyTypeArray = ['Remove Existing SAP Account‘s permission（Exit Users）', 'Extension Valid Date for Your Current Function Role'];
                if (applyTypeArray.includes(window.h3form.applyType.value) || applyTypeArray.includes(window.h3form.applyType1.value)) {
                    dataArray = window.h3form.requestFunctionRole1.value;
                    let tag = 1;
                    for (let i = 0; i < dataArray.length; i++) {
                        for (let j = 0; j < this.selected.length; j++) {
                            if (dataArray[i].functionRoleName1) {
                                if (dataArray[i].functionRoleName1.id === this.selected[j].id) {
                                    if (tag === 1) {
                                        this.$message.error('Repeated addition, deleted duplicate data!');
                                    }
                                    this.selected.splice(j, 1);
                                    tag++;
                                }
                            }
                        }
                    }
                }
                else {
                    let tag = 1;
                    dataArray = window.h3form.requestFunctionRole.value;
                    for (let i = 0; i < dataArray.length; i++) {
                        for (let j = 0; j < this.selected.length; j++) {
                            if (dataArray[i].functionRoleName) {
                                if (dataArray[i].functionRoleName.id === this.selected[j].id) {
                                    if (tag === 1) {
                                        this.$message.error('Repeated addition, deleted duplicate data!');
                                    }
                                    this.selected.splice(j, 1);
                                    tag++;
                                }
                            }
                        }
                    }
                }
            }
            // 二开结束
            // 二开开始 IT Application / My Application / Additional IT Device Application 子表校验去重
            if (this.$route.query.startWorkflowCode === "additional_Application" || this.$route.query.return.split('?')[0].split('/').includes('additional_App')) {
                let addItemArray = window.h3form.addItem.value || [];
                let tag = 1;
                for (let i = 0; i < addItemArray.length; i++) {
                    for (let j = 0; j < this.selected.length; j++) {
                        if (addItemArray[i].model) {
                            if (addItemArray[i].model === this.selected[j].model) {
                                if (tag === 1) {
                                    // this.$message.error('Repeated addition, deleted duplicate data!')
                                }
                                this.selected.splice(j, 1);
                                tag++;
                            }
                        }
                    }
                }
            }
            // 二开结束
            this.selected.forEach((res) => {
                const obj = {};
                this.control.columns.forEach((c) => {
                    if (c.key === this.controlOpts.importFormRelevanceForm) {
                        let formData = res;
                        if (this.mappings) {
                            formData = ReverseQueryService.convertForMappings(res, dataitems, this.mappings, formControls);
                        }
                        obj[c.key] = formData;
                    }
                    else {
                        // obj[c.key] = null;
                    }
                });
                const backRow = this.addRow();
                backRow.value = obj;
            });
            this.selected = [];
            this.onModalCancel();
            setTimeout(() => {
                this.importLink();
                // this.setRelevanceLinkageValue();
            }, 1000);
        });
    }
    customBtnclick(code) {
        super.customBtnclick(code);
    }
    onModalCancel() {
        this.isShowRelevance = false;
    }
    importRelevance() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.isShowRelevance = true;
            this.query = this.getParams(false);
            this.columns = this.relavanceColumns();
            this.formTitleObj = yield RelevanceFormControl.service.getBizmodelTitle(this.schemaCode || '');
        });
    }
    /**
     * 将所有的关联单选执行映射逻辑
     */
    // async setRelevanceLinkageValue() {
    //   let ctrl: any = this.control.controller;
    //   ctrl._cells.forEach((cell: any, rowIdx: number) => {
    //     cell.forEach((item: any) => {
    //       let control = item.control;
    //       if (
    //         control.value &&
    //         control.value.id &&
    //         control.value.schemaCode &&
    //         control.options &&
    //         control.options.mappings
    //       ) {
    //         const relevanceKeyValue: boolean = Object.keys(
    //           control.options.mappings,
    //           ).some((key) => control.value[key] === undefined);
    //         //选中关联单选记录中映射值为undefined时需要通过load接口请求表单详细数据来进行映射
    //         if (relevanceKeyValue) {
    //           // TODO 若出现重复load请求可将这里的请求去掉，只需要重新赋值触发映射逻辑
    //           formApi
    //           .load({
    //             schemaCode: control.value.schemaCode,
    //             objectId: control.value.id,
    //           })
    //           .then(({ data, errcode, errmsg }) => {
    //             if (
    //               data &&
    //               data.bizObject &&
    //               data.bizObject.data &&
    //               data.bizObject.data.id === control.value.id
    //             ) {
    //               control.value = data.bizObject.data;
    //             }
    //           });
    //         } else {
    //           //重新赋值触发映射逻辑
    //           const value = cloneDeep(control.value);
    //           value.$format = false;
    //           control.value = value;
    //         }
    //       }
    //     });
    //   });
    // }
    importFinishe(val) {
        this.importDataNum = val.length + this.rows.length;
        if (!val)
            return;
        for (const col of this.control.columns) {
            val.forEach((row) => {
                if (row[col.key] !== undefined && row[col.key] !== null) {
                    if (col.options.computeFormula) {
                        delete row[col.key];
                    }
                    row[col.key] = FormControlValueService.convert(col.type, row[col.key], col.options && col.options.multi);
                }
                else {
                    row[col.key] = FormBuilderHelper.getControlValue(col);
                }
            });
        }
        for (const row of val) {
            this.addRow(row);
        }
        this.importLink();
        // this.getCtrl().value =val
    }
    importLink() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let ctrl = this.control.controller;
            ctrl._cells.forEach((cell, rowIdx) => {
                cell.forEach((item) => {
                    let control = item.control;
                    if (control.value && control.value.id && control.value.schemaCode && control.options && control.options.mappings && Object.keys(control.options.mappings).some(key => control.value[key] === undefined)) {
                        formApi.load({
                            schemaCode: control.value.schemaCode,
                            objectId: control.value.id,
                        }).then(({ data, errcode, errmsg }) => {
                            if (data && data.bizObject && data.bizObject.data && data.bizObject.data.id == control.value.id) {
                                control.value = data.bizObject.data;
                            }
                        });
                    }
                    //人员单选映射逻辑处理          
                    if (control.value && Array.isArray(control.value) && control.value.length && control.options) {
                        if (control.options.mappings && Object.keys(control.options.mappings).some(key => control.value[key] === undefined)) {
                            const mappingList = control.options.mappings;
                            const staffSelectorControlValue = control.value[0];
                            for (const key in mappingList) {
                                if (Object.prototype.hasOwnProperty.call(mappingList, key)) {
                                    const element = mappingList[key];
                                    const idx = element.indexOf('.');
                                    if (idx > -1) {
                                        const sheetKey = element.substring(0, idx);
                                        const controlKey = element.substr(idx + 1);
                                        const rowIndex = item.rowIndex || ctrl.rowIndex || 0;
                                        const sheetCtrl = this.findController(sheetKey);
                                        if (sheetCtrl) {
                                            const row = sheetCtrl.rows[rowIndex];
                                            const mappingCtrl = row.findChild(controlKey);
                                            if (mappingCtrl) {
                                                if (!staffSelectorControlValue[key]) {
                                                    userApi.getUserInfo(staffSelectorControlValue.id).then(({ data, errcode, errmsg }) => {
                                                        if (data) {
                                                            if (data.hasOwnProperty(key)) {
                                                                //@ts-ignore
                                                                mappingCtrl.value = data[key];
                                                            }
                                                            else {
                                                                //@ts-ignore
                                                                const userExtAttrNode = data.userExtAttrModels.find((item) => item.code === key);
                                                                mappingCtrl.value = userExtAttrNode ? userExtAttrNode.mapVal : '';
                                                            }
                                                        }
                                                    });
                                                }
                                                else {
                                                    mappingCtrl.value = staffSelectorControlValue[key];
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
            });
        });
    }
    closeRepeatModal() {
        this.showRepeatModal = false;
    }
    editFinishe(val) {
        this.closeRepeatModal();
        this.importFinishe(val);
    }
    /**
     * @description: 列表导入时候，人员名称重复，弹出修复数据弹框
     * @param data.errorType 错误类型 data.successCount 成功数量  data.errorCount失败数量  data.fileName 错误模板名称
     * @return:
     */
    repeatErrorHandle(data) {
        this.importStatu.status = data.errorType;
        this.importStatu.successNum = data.successCount;
        this.importStatu.failNum = data.errorCount;
        this.importStatu.fileName = data.fileName;
        this.importData.secondImportData = data.secondImportData || [];
        if (data.data) {
            this.importFinishe(data.data);
        }
        this.showModal = false;
        this.showRepeatModal = true;
    }
    get sheetParams() {
        const formStatus = {
            DRAFT: 0,
            PROCESSING: 1,
            CANCELLED: 2,
            COMPLETED: 3,
        };
        const params = Object.assign({
            startWorkflowCode: this.$route.query.startWorkflowCode,
            workitemId: this.$route.query.workitemId
        }, this.control.options.sheetParams);
        params.sequenceStatus = formStatus[params.sequenceStatus];
        return params;
    }
    toggleQuery() {
        this.isShowQueryItem = !this.isShowQueryItem;
    }
    // 点击搜索
    onSearch(params, nameObj, queryData) {
        console.log(params, nameObj, queryData);
        this.isShowQueryItem = false;
        const Ctrl = this.getCtrl();
        const sheet = Ctrl;
        const formControls = this.getFormControls();
        const sheets = formControls.find((c) => c.key === this.id);
        if (sheet && sheet.rows.length > 0) {
            // 清空子表数据在获取
            this.rows = [];
            // 标记筛选子表
            sessionStorage.setItem('sheet-' + this.id, '1');
            if (Object.keys(params).length) {
                this.queryActive = true;
                const vals = this.dataTranslateToFilterCard(params, nameObj);
                this.queryConditionSource = vals;
                // 获取过滤的数据
                sheet.rows.forEach((g, i) => {
                    if (!this.hasRows(g, params)) {
                        this.buildRow(i, g);
                    }
                });
                // this.initFilterStat(sheets);
            }
            else {
                this.queryActive = false;
                this.queryConditionSource = [];
                sheet.rows.forEach((g, i) => {
                    this.buildRow(i, g);
                });
                // this.initStat();
            }
        }
        this.onCheckAll(false);
    }
    // 筛选过滤条件
    hasRows(objs, params) {
        let status = 0;
        let obj = {};
        for (let key in objs.value) {
            obj[key] = objs.value[key];
        }
        for (let i in params) {
            const arr = Array.isArray(obj[i]) ? obj[i].map((d) => d.id) : [];
            // 支持类型：短文本、日期、数值、选人控件、逻辑、关联表单
            // const type = [1, 3, 4, 50, 51, 8, 80, 81];
            switch (params[i].type) {
                case 0:
                case 1:
                case 2:
                    (obj[i] + '').toLowerCase().indexOf((params[i].value + '').toLowerCase()) > -1 ? 0 : status++;
                    break;
                case 3:
                    // 日期
                    let rowDate = moment(obj[i]).format('YYYY-MM-DD HH:mm:ss');
                    rowDate = rowDate.slice(0, params[i].value.length);
                    // new Date(params[i].value).getTime() === new Date(obj[i]).getTime()
                    rowDate === params[i].value ? 0 : status++;
                    break;
                case 4:
                    if (params[i].value === 'true' || params[i].value === 'false') {
                        // 逻辑
                        JSON.parse(params[i].value) === obj[i] ? 0 : status++;
                    }
                    else {
                        //表单设计数值
                        (obj[i] + '').toLowerCase().indexOf((params[i].value + '').toLowerCase()) > -1 ? 0 : status++;
                    }
                    break;
                case 8:
                    // 逻辑
                    JSON.parse(params[i].value) === obj[i] ? 0 : status++;
                    break;
                case 5:
                case 50:
                case 51:
                case 60:
                case 61:
                case 62:
                case 80:
                case 81:
                    //选人：单选、多选
                    //部门选择：单选、多选
                    //混合选人
                    //关联多选
                    const arr1 = params[i].value.map((d) => d.id);
                    arr.some((r) => arr1.indexOf(r) >= 0) ? 0 : status++;
                    break;
                case 80:
                    // 关联单选
                    params[i].value.hasOwnProperty('id') && params[i].value.id === obj[i].id
                        ? 0
                        : status++;
                    break;
            }
        }
        return status;
    }
    /**
     * 将查询条件转成组件需要的格式
     * @params data 需要转的数据
     */
    dataTranslateToFilterCard(data, nameObj) {
        const deepData = JSON.parse(JSON.stringify(data));
        const vals = [];
        let type = [50, 51, 81];
        Object.keys(deepData).forEach((key) => {
            //
            let content = deepData[key].type === 80
                ? deepData[key].value.name
                : type.indexOf(deepData[key].type) > -1
                    ? deepData[key].value.map((res) => res.name).join(',')
                    : deepData[key].value;
            vals.push({
                name: nameObj[key].name,
                name_i18n: nameObj[key].name_i18n,
                content: content,
                type: -1,
            });
        });
        return vals;
    }
    // 重置
    onReset() {
        this.queryConditionSource = [];
        this.queryData = {};
        this.importDataNum = null;
        this.onSearch({}, {}, {});
    }
    // 点击过滤弹出层外隐藏
    hideQueryItem() {
        if (!this.isShowQueryItem)
            return;
        this.isShowQueryItem = false;
    }
};
tslib_1.__decorate([
    Prop({
        default: false,
    })
], FormSheet.prototype, "canFull", void 0);
tslib_1.__decorate([
    Prop()
], FormSheet.prototype, "formPermission", void 0);
tslib_1.__decorate([
    Inject()
], FormSheet.prototype, "emitSheetColumnResize", void 0);
tslib_1.__decorate([
    Prop({
        default: () => [],
    })
], FormSheet.prototype, "frozenKeys", void 0);
tslib_1.__decorate([
    Watch('isEdit')
], FormSheet.prototype, "onIsEditChange", null);
FormSheet = tslib_1.__decorate([
    Component({
        name: 'form-sheet',
        components: {
            AllEdit: alledit,
            sheetFilter: sheetFilter,
            filterCard: filterCard,
            AModal: Modal,
            AIcon: Icon,
            APopover: Popover,
            ADivider: Divider,
            AButton: Button,
            ACheckbox: Checkbox,
            ATooltip: Tooltip,
            APagination: Pagination,
            ASpin: Spin,
            BaseControlAdapter,
            ImportModals,
            UseRepeatModals,
            H3Panel: common.components.Panel,
            H3SizeSlider: common.components.H3SizeSlider,
            Sheet: SheetComp,
        },
        filters: {
            number: numberFilter,
        },
    })
], FormSheet);
export default FormSheet;
